import { WSButton, WSElement, WSText } from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { getPathWorkLogPayeeDetails } from "../../modules/WorkLogs/paths";
import { useQueryWorkItem } from "../../query/workItem/queries/useQueryWorkItem";
import { useQueryWorkLog } from "../../query/workLog/queries/useQueryWorkLog";

type Props = {
  invoice: IInvoice;
};

export const InvoiceWorkLog: React.FC<Props> = ({ invoice }) => {
  const history = useHistory();

  const workItemId = invoice?.lineItems[0]?.labels?.workItemId as
    | string
    | undefined;

  const queryWorkItem = useQueryWorkItem(workItemId!, {
    enabled: !!workItemId
  });

  const workLogId = queryWorkItem.data?.workLogId;

  const queryWorkLog = useQueryWorkLog(workLogId!, {
    enabled: !!workLogId
  });

  if (!workLogId || !queryWorkLog.data?.workLogNumber) {
    return null;
  }

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray500">
        Created from work log{" "}
        <WSButton.Link
          onClick={() => history.push(getPathWorkLogPayeeDetails(workLogId))}
        >
          #{queryWorkLog.data.workLogNumber}
        </WSButton.Link>
      </WSText.ParagraphSm>
      <WSButton.Link
        mt="M"
        onClick={() => history.push(getPathWorkLogPayeeDetails(workLogId))}
        rightIcon="chevron-right"
      >
        View work log
      </WSButton.Link>
    </WSElement>
  );
};
